import { VideoHero, AboutIntro, PhotoScroll, PicSlide } from '../modules';

function MainPage() {
  return (
    <main className="w-full">
      <VideoHero />
      <AboutIntro />
      <PhotoScroll />
      <PicSlide />
    </main>
  );
}

export default MainPage;
